var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-scale/src/array.js
// module id = ../../../../d3-scale/src/array.js
// module chunks = 4